import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function LoadingScreen() {
    return /*#__PURE__*/ _jsx("div", {
        className: "min-h-screen flex items-center justify-center bg-background-1",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex flex-col items-center gap-4",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "animate-spin rounded-full h-12 w-12 border-b-2 border-navy-90"
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "text-navy-60 text-sm",
                    children: "Loading..."
                })
            ]
        })
    });
}
